<script setup lang="ts">
  import type { IBestBuyBanner } from '@/types/BestBuyBanners'
  import type { TDirection } from '@/components/clp/types'
  import useIndexPageDataLayer from '@/composables/data-layers/useIndexPageDataLayer'

  const props = defineProps<{ data: IBestBuyBanner; selectedDirection: TDirection }>()
  const { locale } = useI18n()
  const url = useRequestURL()

  const globalSettingsStore = useGlobalSettingsStore()
  const { useOldFsf } = storeToRefs(globalSettingsStore)

  const runtimeConfig = useRuntimeConfig()
  const domain = runtimeConfig.public.siteUrl

  const localePath = useLocalePath()
  const bookFlightPath = computed(() => localePath('book-flight'))

  function getFsfUrl(item: IBestBuyBanner) {
    const queryParams = new URLSearchParams({
      sref: 'BBX',
      originType: 'A',
      originCode: item.origin,
      destinType: 'A',
      destinCode: item.dest,
      tripType: props.selectedDirection,
      numAdt: '1',
      numChd: '0',
      numInf: '0',
      return: '',
      upsltab: '',
      returnUrl: url.href,
      selectedMonth: item.monthIndexFromCurrentMonth.toString() || '0'
    })

    if (useOldFsf.value) {
      queryParams.set('opentab', 'ovl')
    }

    if (useOldFsf.value) {
      return `${domain}/${locale.value}/index?${queryParams.toString()}`
    }

    return `${domain}${bookFlightPath.value}?${queryParams.toString()}`
  }

  const { pushBestBuyBannerDataLayer } = useIndexPageDataLayer()
  async function bookNow() {
    const url = getFsfUrl(props.data)
    if (!url) {
      return
    }

    pushBestBuyBannerDataLayer({
      event_action: 'click',
      oac: props.data.origin,
      dac: props.data.dest
    })

    await navigateTo(url, { external: true })
  }
</script>
<template>
  <UiButton
    :title="$t('clp.bookNow')"
    variant="secondary"
    size="lg"
    :disabled="!data.price"
    class="mb-0 w-full rounded-sm bg-bt-blue-ui"
    @click="bookNow()"
  />
</template>
